/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSparse } from '../../factoriesAny.js';
export var sparseDependencies = {
  SparseMatrixDependencies: SparseMatrixDependencies,
  typedDependencies: typedDependencies,
  createSparse: createSparse
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSparse.generated.js
// module id = 1655
// module chunks = 0